import { useQuery } from "@tanstack/react-query";

import subscriptionsApi from "./api";
import { QUERY_KEYS } from "./constants";

const { SUBSCRIPTIONS_LIST } = QUERY_KEYS;

const useFetchSubscriptions = () =>
  useQuery({
    queryKey: [SUBSCRIPTIONS_LIST],
    queryFn: subscriptionsApi.fetchSubscriptions,
  });

export { useFetchSubscriptions };
